var email = document.querySelector('.info-toggler-email');

email.onclick = function() {
    email.classList.toggle('active');
}

var tel = document.querySelector('.info-toggler-telephone');

tel.onclick = function() {
    tel.classList.toggle('active');
}

document.addEventListener("DOMContentLoaded", function() {
    prefillContactForm();
});

function prefillContactForm() {
    let url = new URL(window.location.href);
    let input = url.searchParams.get('product')
    if(input != null && typeof(document.getElementById("ContactForm-message")) != 'undefined' && document.getElementById("ContactForm-message") != null) {
        document.getElementById("ContactForm-message").value = 'Ihre Anfrage für das Produkt: ' + input + '\r' + '\r';
    }
}